import type { SvelteComponent } from 'svelte';
import type { VirtualComponentTypes } from './VirtualComponents';

export type SceneActionUI = {
	delay?: {
		value: number;
		units: string;
	};
	scene_id: string;
	option: string;
};

export type SceneVirtualActionUIProps = {
	name: string;
	id: string;
	index: number;
	type: VirtualComponentTypes;
	values?: SceneVirtualActionUIPropValue[];
	icon?: string;
	config?: any;
	title?: string; //Override property title in Action Wizard UI
	alert?: boolean;
};

export type SceneVirtualActionUIPropValue = {
	title: string;
	value: string;
	icon?: string;
};

export type SceneActionComponentUI = {
	component: typeof SvelteComponent;
	actions: SceneVirtualActionUIProps[]; //@TODO: There are other possible types here
	title?: string;
};

export function is_play_scene_action_ui(o: any): o is SceneActionUI {
	return (
		typeof o === 'object' &&
		typeof o.scene_id === 'string' &&
		['with_if_evaluation', 'without_if_evaluation'].includes(o.option)
	);
}

export function is_enable_disable_scene_action_ui(o: any): o is SceneActionUI {
	return (
		typeof o === 'object' &&
		typeof o.scene_id === 'string' &&
		[
			'action_enable_scene',
			'action_disable_scene',
			'action_toggle_scene',
			'action_enable_alarm',
			'action_disable_alarm',
			'action_toggle_alarm',
		].includes(o.option)
	);
}
